<template>
  <article v-if="!isLoading && article !== null" class="article">
    <div class="columns has-margin-bottom-md">

      <div class="column is-8">
        <h1 class="title">{{ article.title }}</h1>
        <h2 class="subtitle">{{ article.description }}</h2>
      </div>

      <div class="column is-4 has-text-right">
        <b-field
          v-if="$auth.check(['admin', 'support'])"
          class="has-margin-bottom-sm"
          position="is-right">
          <p class="control">
            <router-link
              :to="{ name: 'edit-article', params: { article: article.id } }"
              class="button is-primary">
              <b-icon icon="pencil-alt" size="is-small" />
              <span v-t="'edit_button'" />
            </router-link>
          </p>
          <p class="control">
            <button
              class="button is-danger"
              @click.prevent="destroy($event, article.id)">
              <b-icon icon="times" size="is-small" />
              <span v-t="'delete_button'" />
            </button>
          </p>
        </b-field>

        <time class="has-text-grey" :datetime="article.updated_at">
          {{ $t('last_revision', { date: lastUpdate }) }}
        </time>
      </div>

    </div>

    <div class="content" v-html="article.content" />
    <article-feedback :article="article.id" />

  </article>
  <loading-content v-else />
</template>

<script>
import API from '@/api'
import Utils from '@/utils'
import { mapMutations } from 'vuex'
import LoadingContent from './LoadingContent'
import ArticleFeedback from './ArticleFeedback'

export default {
  name: 'ArticleContent',
  props: { product: { type: Object, required: true } },
  components: {
    LoadingContent,
    ArticleFeedback
  },
  data () {
    return {
      isLoading: true,
      pageTitle: '',
      article: null
    }
  },
  mounted () {
    this.fetchData()
  },
  watch: {
    articleSlug () {
      this.article = null
      this.fetchData()
    }
  },
  methods: {
    fetchData () {
      this.isLoading = true
      API.articles.findBySlug(this.product.id, this.articleSlug, article => {
        if (article === null) {
          this.$router.push({ name: '404-error' })
        }

        // Define o título da página
        this.pageTitle = article.title + ' | ' + article.product.name

        this.article = article
        this.isLoading = false
      })
    },

    // Remove o artigo com base em sua ID
    destroy (event, id) {
      Utils.alertConfirmation(
        this.$t('delete_alert'),
        toast => {
          API.articles.destroy(id, () => {
            this.$snotify.remove(toast.id)
            this.$router.push({ name: 'manual', params: { product: this.product.slug } })
            this.removeArticleFromIndex(id)
          })
        },
        toast => this.$snotify.remove(toast.id),
        this.$snotify
      )
    },
    ...mapMutations({ removeArticleFromIndex: 'article/removeArticle' })
  },
  computed: {
    articleSlug () {
      return this.$route.params.article
    },
    lastUpdate () {
      return Utils.timeAgo(this.article.updated_at, this.$i18n.locale)
    }
  },
  metaInfo () {
    return {
      title: this.pageTitle
    }
  }
}
</script>

<i18n>
{
  "en-US": {
    "last_revision": "Last revision {date}",
    "edit_button": "Edit",
    "delete_button": "Remove",
    "delete_alert": "Are you sure you want to remove this article?"
  },
  "pt-BR": {
    "last_revision": "Última revisão {date}",
    "edit_button": "Editar",
    "delete_button": "Remover",
    "delete_alert": "Tem certeza que deseja remover este artigo?"
  }
}
</i18n>
